
import React, { FC } from 'react';
import { FontAwesomeIcon, FontAwesomeIcons } from 'src/constants/fontAwesomeIcons';
import useDispatch, { useActionCreator } from 'src/hooks/useDispatch';
import useSelector from 'src/hooks/useSelector';
import * as NavigationActions from '../../../actions/navigation';

import './NavBurgerButton.scss';

const NavBurgerButton: FC = () => {

    const isOpen = useSelector(state => state.navigation.isOpen);
    
    const dispatch = useDispatch();
    const toggleNavigationDrawer = useActionCreator(NavigationActions.ToggleNavigationDrawer, dispatch);

    return (
        <button
            className="nav-button-burger"
            onClick={() => {
                toggleNavigationDrawer(!isOpen)
            }}
            type="button"
        >
            {
                isOpen ?
                <FontAwesomeIcon 
                    className="nav-button-burger-icon"
                    icon={FontAwesomeIcons.Regular.TIMES} 
                    fixedWidth
                /> :
                <FontAwesomeIcon 
                    className="nav-button-burger-icon"
                    icon={FontAwesomeIcons.Solid.HAMBURGER} 
                    fixedWidth
                />
            }
        </button>
    );
}


export default NavBurgerButton;